export const portugueseTranslation =
{
    "translationLanguageInLocal": `Português Brasileiro`,
    "metaTags": {
        "homeTitle": "klino.gr",
        "homeDescription": "foo",
        "homeKeywords": "foo",
    },
}
